// 部门图表
export const departmentColor = ["#1dabbc",
    "#fec029", "#ff6e6e", "#3ef5ad", "#5fd4fe",
    "#ffe375", "#ccff99", "#66a228", "#f2783d", "#336699",
    "#a27f59", "#8c8c8c", "#4e2f52", "#ccccff", "#99cccc", "#999933", "#d979e4"];

// 尖峰平谷
export const jFPGColor = ["#fe7f66", "#fdca50", "#0091ea", "#29b85e"];

// 能源颜色  电、水、蒸汽、天然气、油
export const energyColor = ["#3ef5a3", "#2fbecf", "#fff", "#ff933e", "#cccacb"];

//同期 环比  或者  综合能耗、万元综合能耗
export const sameAndCircle = ["#1dabbc", "#fec029"];